module.exports = __webpack_public_path__ + "static/media/PZL-37.9f65b1c7.jpg";